import { FlatPickrDirective } from './../../plugins/flatpickr/flatpickr.directive';
import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import {
  Component,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  NgZone
} from '@angular/core';
import { IKeyValueInterface, BookingStatus } from './../../shared/config';
import {
  BookingTripDetail,
  BookingInformation,
  Expense
} from '../models/booking-information.model';
import { Router } from '@angular/router';
import { FlatPickrModel } from './../../plugins/flatpickr/flatpickr.model';
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import {
  WeGoConfig,
  IAPIResponse,
  ApplicationRouteURL
} from '../../shared/config';
import { UnlockService } from '../models/unlock.service';
import { BookingService } from './../models/booking.service';
import { DropdownModel } from '../../report/models/report-filter.model';
import { CostAndExpenseService } from '../../cost-expenses/models/cost-expense.service';

const moment = require('moment');

@Component({
  selector: 'wego-booking-expense-popup',
  template: require('../views/booking-expense-popup.component.html'),
  providers: [CostAndExpenseService]
})
export class BookingExpensePopupComponent implements OnInit {
  apiErrorMsg: any;
  costTypeList: any;
  public isLoading: boolean;
  public headers: any;
  public errorModel: IKeyValueInterface[];
  public errorMsg: string;
  public model: Expense = new Expense();
  public contractTypeGroupList: any;
  public dateFormat: string = WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
  vatSettingList: DropdownModel[];
  vatSettingDefaultCost: boolean;

  @ViewChild('bookingExpenseModal') public bookingExpenseModal: any;

  @Output('OnSuccessSave') onSuccessSave = new EventEmitter();
  @Input('BookingInfoModel') bookingInfoModel: any;
  @Input('BookingHashId') bookingHashId: string;
  constructor(
    private authService: AuthService,
    private router: Router,
    private translate: TranslateService,
    private zone: NgZone,
    private bookingService: BookingService,
    private costAndExpenseService: CostAndExpenseService
  ) {}

  ngOnInit() {
    this.headers = this.authService.GetHeaderForFile();
    this.GetVatSettingDropdownList();
  }

  public show(): void {
    this.errorMsg = '';
    this.errorModel = [];
    this.bookingExpenseModal.show();
    this.GetCostTypeList();
  }

  public hide(): void {
    this.model = new Expense();
    this.bookingExpenseModal.hide();
  }

  private OnSuccessSave() {
    this.hide();
    let successMsg = this.translate.instant('LblExpenseSuccess');
    this.onSuccessSave.emit({ SuccessMessage: successMsg });
  }

  public OnSubmit(forms: any) {
    if (this.model) {
      this.bookingService.UpdateUserExpense(this.model).subscribe(
        res => {
          this.isLoading = false;
          if (res.data) {
            this.OnSuccessSave();
          } else {
            this.errorModel = res.error;
            this.errorMsg = res.error;
          }
        },
        error => {
          this.errorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
    }
  }

  public GetVatSettingDropdownList() {
    this.bookingService.GetVatSettingDropdownList(this.bookingHashId).subscribe(
      res => {
        if (res.data) {
          this.vatSettingList = res.data;
          //this.GetVatSettingDefaultValues();
        } else {
          this.errorModel = res.error;
        }
      },
      error => {
        this.errorMsg = this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  public GetVatSettingDefaultValues() {
    this.bookingService
      .GetVatSettingDefaultValues(this.bookingHashId)
      .subscribe(
        res => {
          if (res.data) {
            const vatSettingDefaultValues = res.data;
            this.vatSettingDefaultCost =
              vatSettingDefaultValues.vatSettingDefaultCost;
          } else {
            this.errorModel = res.error;
          }
        },
        error => {
          this.errorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public GetCostTypeList() {
    this.costAndExpenseService.GetDropdownCostTypeList().subscribe(
      res => {
        this.costTypeList = res.data;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  public SetVatDefaultCost(vatSettingDefaultCost: boolean) {
    return vatSettingDefaultCost
      ? this.translate.instant('LblExcludingVat')
      : this.translate.instant('LblIncludingVat');
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/booking/components/booking-expense-popup.component.ts